// extracted by mini-css-extract-plugin
export default {"HeroCardArticles":"FElBYDoQDI","HeroCardArticleContent":"Nk7Ljo5AFM","HeroCardArticleContentSwap":"CvIDruD67h"};